<script setup lang="ts">
import ConfirmationDialog from '@/uiKit/ConfirmationDialog.vue'

defineProps<{ name: string }>()
defineEmits<{ close: []; confirm: [] }>()

const isOpen = defineModel<boolean>('open', { default: false })
</script>

<template>
  <ConfirmationDialog
    :open="isOpen"
    :title="`Discard changes?`"
    :description="`You have unsaved changes to “${name}”.\nIf you leave now, your changes will not be saved.`"
    confirm-text="Discard changes"
    variant="critical"
    cancel-text="Keep editing"
    @close="isOpen = false"
    @confirm="$emit('confirm')"
  />
</template>
